import type { SgwtChatbotConversation, SgwtChatbotMessage } from '../../shared/chatbot.types';
import type { DxAssistantConversation, DxAssistantMessage, DxAssistantPromptResponse } from './dx-assistant.types';

const SOURCES_SEPARATOR = /\nSources:\n/;

function convertPromptResponse(dxMessage: DxAssistantPromptResponse): SgwtChatbotMessage {
  const [content, sources] = dxMessage.responseMessage.content.split(SOURCES_SEPARATOR);
  console.debug('Converted prompt response:', { html: content, sources });

  return {
    conversationId: dxMessage.conversationId,
    role: 'bot',
    id: dxMessage.responseMessage.messageId,
    message: {
      content: content,
      format: 'markdown',
    },
    sources: {
      content: sources || '',
      format: 'markdown',
    },
  };
}

function convertMessage(conversationId: string, dxMessage: DxAssistantMessage): SgwtChatbotMessage {
  const [content, sources] = dxMessage.content.split(SOURCES_SEPARATOR);
  return {
    conversationId,
    id: dxMessage.messageId,
    role: dxMessage.role === 'user' ? 'user' : 'bot',
    message: {
      content: content,
      format: 'markdown',
    },
    sources: {
      content: sources || '',
      format: 'markdown',
    },
  };
}

function convertConversation(dxConversation: DxAssistantConversation): SgwtChatbotConversation {
  return {
    conversationId: dxConversation.conversationId,
    messages: dxConversation.messages.map((msg) => convertMessage(dxConversation.conversationId, msg)),
    metadata: {
      created: dxConversation.metadata.created.at,
      updated: dxConversation.metadata.updated.at,
    },
  };
}

export const DxConverter = {
  convertPromptResponse,
  convertMessage,
  convertConversation,
};
